import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/feature/update/feature.update.mutation.gql"
import type {
  FeatureUpdateMutation,
  FeatureUpdateMutationVariables,
} from "@/v2-backoffice-client/feature/update/__types__/feature.update.mutation"

type Options = MutationHookOptions<
  FeatureUpdateMutation,
  FeatureUpdateMutationVariables
>

export function useFeatureUpdateMutation(options?: Options) {
  return useMutation<FeatureUpdateMutation, FeatureUpdateMutationVariables>(
    mutation,
    options,
  )
}
